import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import VFormCard from '../../../Venti-UI-Kit/VForms/VFormCard/VFormCard';
import VTextInput from '../../../Venti-UI-Kit/VInputs/VTextInput/VTextInput';
import { INPUT_TYPE, USER_PERMISSIONS } from '../../../constants/types';
import { handleRequestHelper } from '../../../utils/helpers';
import api from '../../../api/api';
import { FLAGS } from '../../../constants/constants';
import { useAuth } from '../../../Providers/AuthProvider/AuthProvider';

const MetaPixelForm = ({ onChange, formState }) => {
  const { producerId } = useParams();
  const { user } = useAuth();
  const [showMetaPixelForm, setShowMetaPixelForm] = useState(false);

  const getMetaPixelFlag = async () => {
    await handleRequestHelper({
      endpoint: () => api.getFlag(FLAGS.META_PIXEL_ENABLED),
      onSuccess: ({ flag }) => {
        setShowMetaPixelForm(
          flag.context.enabled && flag.userIdAllowList.includes(Number(producerId))
        );
      },
    });
  };

  useEffect(() => {
    getMetaPixelFlag();
  }, []);

  if (user.role !== USER_PERMISSIONS.SUPER_ADMIN && !showMetaPixelForm) return null;

  return (
    <VFormCard
      label="Meta Pixel"
      description="Completa con el ID y el Access Token de tu Meta Pixel."
    >
      <VTextInput
        title="Pixel ID"
        name="metaPixelId"
        onChange={onChange}
        defaultValue={formState.metaPixelId?.value}
        errorMessage={formState.metaPixelId?.error}
        autoComplete={false}
      />
      <VTextInput
        title="Access Token"
        name="metaAccessToken"
        onChange={onChange}
        defaultValue={formState.metaAccessToken?.value}
        errorMessage={formState.metaAccessToken?.error}
        type={INPUT_TYPE.PASSWORD}
        autoComplete={false}
      />
    </VFormCard>
  );
};

export default MetaPixelForm;
